module.exports = __webpack_public_path__ + "img/secure.e0f82a09.svg";